"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RELEASE_SLOT_RESPONSE_EXAMPLE = exports.APPOINTMENT_SLOT_HOLD_RESPONSE_EXAMPLE = exports.AVAILABLE_SLOT_RESPONSE_EXAMPLE = void 0;
exports.AVAILABLE_SLOT_RESPONSE_EXAMPLE = [
    {
        doctorId: '22222222-2222-2222-2222-222222222222',
        scheduledAt: '2026-08-01T10:00:00.000Z',
        durationMinutes: 15,
        sessionCategory: 'GENERAL',
        consultationModes: ['IN_PERSON'],
    },
];
exports.APPOINTMENT_SLOT_HOLD_RESPONSE_EXAMPLE = {
    id: '60000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    branchId: '33333333-3333-3333-3333-333333333333',
    departmentId: '44444444-4444-4444-4444-444444444444',
    doctorId: '22222222-2222-2222-2222-222222222222',
    patientId: '11111111-1111-1111-1111-111111111111',
    scheduledAt: '2026-08-01T10:00:00.000Z',
    durationMinutes: 15,
    holdToken: 'abcd1234efgh5678',
    expiresAt: '2026-07-11T09:05:00.000Z',
    createdAt: '2026-07-11T09:00:00.000Z',
};
exports.RELEASE_SLOT_RESPONSE_EXAMPLE = { released: true };
//# sourceMappingURL=slot-management.response.js.map